import React, { useState } from "react";
import { useUniqueId } from "shared/uniqueId/useUniqueId";
import { useTranslation } from "shared/i18n/useTranslation";
import { useFetchJson } from "shared/fetch/useFetchJson";
import { FetchJsonError, FetchJsonReturnType } from "shared/fetch/fetchJson";
import { User } from "api/auth/types/user";

interface LoginType {
  handleSubmit?: (e: React.SyntheticEvent) => void;
  handleSuccess?: (fetchJsonResponse: FetchJsonReturnType<User>) => void;
  handleError?: (fetchJsonResponse: FetchJsonError) => void;
}

export function Login({ handleSubmit, handleSuccess, handleError }: LoginType) {
  const { uid: getUniqueId } = useUniqueId("login-");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { run, isRunning } = useFetchJson<User>();
  const { translate } = useTranslation();

  function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value);
  }

  function handlePasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
    setPassword(e.target.value);
  }

  function handleSubmitDefault(e: React.SyntheticEvent): void {
    e.preventDefault();
    run("/auth/api/login", {
      method: "post",
      body: {
        email: email,
        password: password,
      },
    })
      .then((fetchJsonResponse) => {
        if (handleSuccess) handleSuccess(fetchJsonResponse);
      })
      .catch((err: FetchJsonError) => {
        if (handleError) handleError(err);
        else throw err;
      });
  }

  return (
    <form onSubmit={handleSubmit ?? handleSubmitDefault}>
      <div className="mb-3">
        <label htmlFor={getUniqueId("email")} className="form-label">
          {translate("__email")}
        </label>
        <input
          type="email"
          className="form-control"
          id={getUniqueId("email")}
          value={email}
          onChange={handleEmailChange}
        />
      </div>
      <div className="mb-3">
        <label htmlFor={getUniqueId("password")} className="form-label">
          {translate("__password")}
        </label>
        <input
          type="password"
          className="form-control"
          id={getUniqueId("password")}
          value={password}
          onChange={handlePasswordChange}
        />
      </div>
      <button type="submit" className="btn btn-primary" disabled={isRunning}>
        {translate("__login")}
      </button>

      <a href="forgotPassword" className={`d-block text-center `}>
        {translate("__forgotPassword?")}
      </a>
    </form>
  );
}
